export const name = "COS";
export const summary = `Computes the cosine of \`X\`.`;
export const reference = `
## COS

Computes the cosine of \`X\`.

\`\`\`
COS(X)
\`\`\`

### Description

Computes the cosine of X where X is specified in radians. Never fails.

| X | COS(X) |
| --- | --- |
| \`+inf\` | \`NaN\` |
| \`-inf\` | \`NaN\` |
| \`NaN\` | \`NaN\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
